import type React from 'react';

import { useProducts } from '../../model';
import { ProductCard } from '../product-card';

export const Products: React.FC = () => {
	const products = useProducts();

	return (
		<>
			{products.items && products.items.map((item) => <ProductCard key={item.id} product={item} />)}
		</>
	);
};
